import React, { Fragment, useEffect } from 'react'
import { useApi } from '../../hooks/useApi'
import axios from 'axios'
import { ApiConfig } from '../../config/api'
import { PickingRouteTable } from './PickingRouteTable'
import { Status } from '../../hooks/useFetchState'
import { PickingRoute } from '../../interfaces/PickingRouteAdmin/PickingRoute'

interface WorkOrderBlogProps {
  workOrderId: number
}

const getPickingRouteSummary = (
  workOrderId: number
) => {
  const url = new URL(`${ApiConfig.PickingRouteSummaryApi}`)

  url.searchParams.set('workOrderId', workOrderId.toString())

  return axios.get(url.toString())
}

export const PickingRouteComponent: React.FC<WorkOrderBlogProps> = ({
  workOrderId
}) => {
  const { state, callApi } = useApi<PickingRoute[]>()

  const requestWorkOrderBlogs = () => {
    callApi(getPickingRouteSummary(workOrderId))
  }

  useEffect(() => {
    requestWorkOrderBlogs()
  }, [])
  return (
    <Fragment>
      <PickingRouteTable
        pickingRoutes={state.data || []}
        isLoading={state.status === Status.Loading}
      />
    </Fragment>
  )
}
